import * as React from 'react';
import AxiosSingletonLoader from 'src/component/Global/AxiosSingletonLoader';
import System from "../../helper/system";
import Constants from 'src/helper/Constants';
import { useProductInventoryPriceStore } from 'src/hooks/productInventoryPrice';

const AddToBom = (props) => {
    const { single_product, isBomPLP, bomNoMatchType } = props;
    const bomId = System.getParams().bomId
    const bomDetailId = System.getParams().bomDetailId
    const [{ }, { get_pricing_by_id }, { }] = useProductInventoryPriceStore();
    
    const getDisplayStatus = () => {
        return !!(single_product && isBomPLP)
    };
    
    const addToBomOrSwap = () => {
        System.popup('AddedToBomPopup', { single_product: single_product, bomId, bomDetailId, bomNoMatchType })
    };

    return (
        <>
            {(getDisplayStatus() &&
                <>
                    <AxiosSingletonLoader
                        customAxiosButtonIndicatorRunTimeLoader={true}
                        slugKey={['BOM_SWAP_PART_NUMBER_API_CALL', 'PRODUCT_LISTING_API_CALL', 'BOM_OPERATION_API_CALL', 'PRODUCT_INVENTORY_API_CALL', 'CART_API_CALL']}>
                        <button onClick={() => {
                            addToBomOrSwap()
                        }} className="bs5 btn btn-primary w-100">Add To Bom
                        </button>
                    </AxiosSingletonLoader>

                    {single_product && !single_product.ObsoleteFlag &&
                        <div className="mt-1">
                            <a href={void (0)} className="text-blue" onClick={() => {
                                System.popup('QuotePopup', {
                                    single_product: single_product,
                                    addFrom: Constants.systemModules.PLP,
                                    single_product_pricing_list: get_pricing_by_id({
                                        ItemNumber: single_product.ItemNumber
                                    })
                                })
                            }}>Click To Quote</a>
                        </div>
                    }
                </>
            )
            }
        </>

    );
};

export default AddToBom;